// extracted by mini-css-extract-plugin
export var container = "_bi-0";
export var containerTopRight = "_bi-1";